export default __webpack_public_path__ + "static/6lanuna-01d614bae1d9af1c8cf5bc1148268a2c.png";